export default {
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
};
